<template>
	<div class="component-container">
		<div class="heading">
			<p style="width:100%"><strong>CONFIGURATION SETTINGS</strong> <span v-if="cmsVersion" style="float:right;color:greenyellow">version {{ cmsVersion }}</span></p>
			<div style="display:flex;flex-grow:1;flex-direction: row-reverse;">
				&nbsp;
			</div>
		</div>
		<div class="content configuration" ref="content">
			<form
				name="configs"
				@keydown.enter.prevent="() => {}"
				style="width:100%;">
			<table class="list" cellpadding="0" cellspacing="0" width="100%" style="color:#fff;">
				<thead class="list-heading">
					<tr>
						<th width="30%">
							<button class="btn btn-icon" style="min-height:50px">
								Property
							</button>
						</th>
						<th>
							<button class="btn btn-icon">
								Value
							</button>
						</th>
					</tr>
				</thead>
				<tr
					:key="field.name"
					v-for="field in formFields"
					class="list-item">
					<td :style="{height:field.rowHeight?field.rowHeight:'initial'}">
						<p>
							<strong>{{field.label}}</strong><span v-if="field.tooltip" class="tooltip">{{field.tooltip}}</span><br>
							<small style="color:#ccc">{{field.description}}</small>
							<!-- TODO pages url in config.json -->
							<small style="color:#ccc" v-if="field.name === 'sitemap' || field.name === 'robots'">
								&nbsp; <a :href="(WEBSITE_URL ? WEBSITE_URL : './published')+'/'+field.name+(field.name === 'sitemap' ? '.xml' : '.txt')" target="_blank" title="check for current uploaded file"><font-awesome-icon
								:icon="['fas', 'external-link-square-alt']"></font-awesome-icon></a>
							</small>
						</p>
					</td>
					<td>
						<input
							v-if="['sitemap', 'robots'].indexOf(field.name) === -1"
							:type="field.type"
							:name="field.name"
							:value="field.value"
							>
						<input
							v-if="field.name === 'sitemap'"
							accept=".xml"
							:type="field.type"
							:name="field.name"
							:value="field.value"
							>
						<input
							v-if="field.name === 'robots'"
							accept=".txt"
							:type="field.type"
							:name="field.name"
							:value="field.value"
							>
					</td>
				</tr>
			</table>
			<div class="sub-heading">
				<h4>CONFIGURATION GLOBALS PROPERTIES:</h4>
			</div>
			<div :key="globalsProp"
				v-for="(globalsConfigBranch, globalsProp) in globalsConfig"
				class="config-main-lvl">
				<div :name="globalsProp" class="sub-sub-heading">
					<p style="font-size:105%;">
						<strong>__globals.{{ globalsProp }}:</strong> &nbsp;<tooltip :text="`next fields will be under: __globals.${globalsProp}`"></tooltip>
					</p>
				</div>
				<template
					v-if="globalsProp !== 'custom'">
					<table
						:key="field.name"
						v-for="field in globalsConfigBranch.fields"
						width="98%"
						align="center">
						<tr class="list-item" v-if="fieldConditionPass(field)">
							<td height="70" width="30%">
								<small>
									<span style="padding-left:3em;">
										&ndash; {{ field.label }}
									</span>
									&nbsp; <tooltip v-if="field.description" :text="field.description"/>
								</small>
							</td>
							<td height="70" width="70%">
								<input
									v-if="['text', 'number', 'date', 'email', 'phone', 'color'].indexOf(field.type) > -1"
									:type="field.type"
									:name="field.name"
									v-model="field.value"
									:placeholder="field.placeholder"
									:pattern="field.pattern"
									@blur="validateInput($event)"
									:autocomplete="field.autocomplete || 'off'"
									class="confield">
								<label
									v-if="field.type === 'checkbox'"
									:key="field.value"
									style="width:auto;display:inline-block;margin-top:15px;">
									<input
										:type="field.type"
										:name="field.name"
										v-model="field.value"
										:true-value="field.trueValue"
										:false-value="field.falseValue"
										:placeholder="field.placeholder"
										class="confield"
										style="min-width:initial;width:1.5rem;height:1.5rem;display:inline-block;vertical-align: sub;">
										&nbsp;<span v-if="field.value === field.trueValue">Enabled</span><span v-else>Disabled</span>
								</label>
								<div
									v-if="field.type === 'checkbox' && field.trueChildrenFields && field.value === field.trueValue"
									class=""
									style="color: rgb(204, 204, 204);position: relative;padding: 15px;background-color: #555;margin-top: 10px;">
									<label
										:key="f.name"
										v-for="f in field.trueChildrenFields"
										style="display:inline-block;min-width: 300px;"
										>
										<input
											:name="f.name"
											:type="f.type"
											v-model="f.value"
											:true-value="field.trueValue"
											:false-value="field.falseValue"
											style="width:20px;height:20px;"> {{ f.label }}
									</label>
								</div>
								<dynamic-select
									v-if="field.type === 'dynamic-select'"
									:name="field.name"
									:url="field.url"
									:dataPath="field.dataPath"
									:valueProp="field.valueProp"
									:displayProp="field.displayProp"
									:value="field.value"
									@gotOptions="field.selectOptions = $event"
									classes="confield">
									<option value="">Select {{ field.label }}</option>
									<option
										:key="key"
										v-for="(val, key) in field.selectOptions"
										:selected="key === field.defaultValue"
										:value="key">{{ val }}</option>
								</dynamic-select>
								<select
									v-if="field.type === 'select'"
									:name="field.name"
									@blur="validateInput($event)"
									:pattern="field.pattern" class="confield">
									<option value="">Select {{ field.label }}</option>
									<option
										:key="key"
										v-for="(val, key) in field.selectOptions"
										:selected="key === field.defaultValue"
										:value="key">{{ val }}</option>
								</select>
								<select
									v-if="field.type === 'container' && field.selectOptions"
									:pattern="field.pattern"
									@change="onContainerFieldSelected($event, field)"
									@blur="validateInput($event)"
									class="confield" style="margin-top:15px">
									<option value="">Select {{ field.label }}</option>
									<option
										:key="key"
										v-for="(val, key) in field.selectOptions"
										:hidden="field.tempItems.indexOf(key) > -1"
										:value="key">{{ val }}</option>
								</select>
								<div
									v-if="field.type === 'container'">
									<!-- <input
										type="text"
										:value="field.value"
										:placeholder="field.placeholder"
										class="confield"> &nbsp;<button type="button" class="btn btn-green">&plus; ADD</button> -->
									<languages-config
										v-if="field.label === 'Languages'"
										:inputName="field.name"
										:inputValue="field.value"
										:tempParentItems="field.tempItems"
										:defaultItem="field.default"
										:translationsRefresh="field.translationsRefresh"
										></languages-config>
									<currency-config
										v-if="field.label.toLowerCase().indexOf('currenc') > -1"
										:inputName="field.name"
										:inputValue="field.value"
										:tempParentItems="field.tempItems"
										:displayItem="field.display"
										:providerItem="field.provider"
										></currency-config>
									<div
										v-if="fieldNotLangOrCurr(field)"
										class="dashed-container">
										<label
											:key="item"
											v-for="item in field.tempItems">
											<span>{{ item }}</span> <font-awesome-icon
														@click.prevent="field.tempItems.splice(field.tempItems.indexOf(item), 1)"
														title="remove"
														:icon="['fas', 'times']"></font-awesome-icon>
											<input type="hidden" :name="field.name" :value="item">
										</label>
									</div>
								</div>
								&nbsp;&nbsp;<tooltip v-if="field.tooltip" :text="field.tooltip"/>
							</td>
						</tr>
						<!-- <tr>
							<td colspan="2" class="" align="center" style="border-top:1px solid #333;padding-top:3em;padding-bottom:3em;">
								<button
									@click.prevent="save()"
									type="button"
									class="btn btn-green">SAVE</button>
							</td>
						</tr> -->
					</table>
				</template>
				<template
					v-if="globalsProp === 'custom'">
					<table
						width="98%"
						align="center"
						style="position:relative;overflow:visible;z-index:10;">
						<tr class="list-item">
							<td height="70" width="30%">
								<small>
									<span style="padding-left:3em;">add custom <code>key:value</code> pairs</span>
								</small>
							</td>
							<td height="70" width="70%">
								<label>
									<input type="text"
										name="customKey"
										v-model="customKeyField"
										@input.prevent="correctCustomKeyField($event)"
										placeholder="key"
										@keydown.enter.prevent="addCustomField"
										minlength="1"
										pattern="[A-z0-9]+"
										autocomplete="off"
										style="margin: 0 15px 0 0;height:15px;">
								</label>
								<label>
									<input type="text"
										name="customValue"
										v-model="customValueField"
										@keydown.enter.prevent="addCustomField"
										placeholder="value"
										autocomplete="off"
										style="height:15px;">
								</label>
								<button type="button"
									@click.prevent="addCustomField"
									class="btn btn-green"
									style="margin-left: 15px; font-size: 16px; height: 30px; padding: 0px 1em;">
									ADD
								</button>
							</td>
						</tr>
						<tr :key="fieldIdx" v-for="(field, fieldIdx) in globalsConfig.custom.fields" class="list-item">
							<td height="70" width="30%">
								<a href="#"
									@click.prevent="removeCustomField(fieldIdx)"
									class="customfield-rem"
									:title="`remove property ${field.label}`">
									<font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
								</a>
								<span style="padding-left:3em;">{{field.label}}</span>
								<input type="hidden"
									:name="field.name"
									:value="field.value">
								<small>&nbsp;&nbsp;<tooltip :text="field.tooltip"></tooltip></small>
							</td>
							<td height="70" width="70%">
								<span>{{field.value}}</span>
							</td>
						</tr>
					</table>
				</template>
			</div>
			<div class="config-main-lvl" style="text-align:center;">
				<button
					type="button" @click.prevent="save"
					title="Save configuration"
					class="btn btn-green btn-save mt15"><font-awesome-icon :icon="['far', 'save']"></font-awesome-icon> SAVE</button>
			</div>
			<div class="clearfix" style="margin-bottom:15px"></div>
			</form>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import config from '@/mixins/configuration-form'
import TooltipIcon from '@/components/TooltipIcon'
import LangConfig from '@/components/ConfigurationLang'
import CurrConfig from '@/components/ConfigurationCurr'
import DynamicSelect from '@/components/shared/DynamicSelect'

// const GLOBALS_PROPS = ['app', 'client', 'project', 'custom']
const CUSTOM_FIELD_MODEL = {
	label: '',
	name: '',
	type: 'text',
	value: '',
	tooltip: '',
	rowHeight: '70px'
}
const _buildCustomFieldObject = (key, val) => {
	const fieldObject = JSON.parse(JSON.stringify(CUSTOM_FIELD_MODEL))
	fieldObject.label = key
	fieldObject.name = 'custom.' + key
	fieldObject.value = val
	fieldObject.tooltip = '__globals.custom.' + key

	return fieldObject
}
const _isInputValid = (inp) => {
	return inp.checkValidity()
}

export default {
	components: {
		'tooltip': TooltipIcon,
		'languages-config': LangConfig,
		'currency-config': CurrConfig,
		'dynamic-select': DynamicSelect
	},
	data () {
		return {
			formFields: JSON.parse(JSON.stringify(config.formFields)),
			globalsConfig: JSON.parse(JSON.stringify(config.globals)),
			configPage: '',
			customKeyField: '',
			customValueField: ''
		}
	},
	methods: {
		dataFill () {
			const data = this.retrievedData
			if (data) {
				for (let prop in this.globalsConfig) {
					if (data.hasOwnProperty(prop)) {
						if (prop === 'app') {
							if (data.app.services) {
								data.app.services.forEach(service => {
									this.globalsConfig.app.fields.find(f => f.label === 'Services').tempItems.push(service)
								})
							}
							if (data[prop]) {
								const appFields = this.globalsConfig.app.fields
								for (let propName in data[prop]) {
									if (appFields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1)) {
										appFields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1).value = data[prop][propName]
									}
								}
							}
						}
						if (prop === 'project') {
							const projectFields = this.globalsConfig.project.fields
							if (data[prop]) {
								for (let propName in data[prop]) {
									if (propName !== 'language' && propName !== 'currency' && data[prop][propName]) {
										if (projectFields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1)) {
											projectFields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1).value = data[prop][propName]
										}
									}
								}
							}
							if (data.project) {
								for (let propName in data.project) {
									if (data.project[propName]) {
										if (propName === 'language') {
											projectFields.find(f => f.label === 'Languages').tempItems = data.project.language.list
											projectFields.find(f => f.label === 'Languages').default = data.project.language.default
											projectFields.find(f => f.label === 'Languages').translationsRefresh = data.project.language.translationsRefresh
										}
										if (propName === 'currency') {
											projectFields.find(f => f.label === 'Currencies').tempItems = data.project.currency.list
											projectFields.find(f => f.label === 'Currencies').display = data.project.currency.display
											projectFields.find(f => f.label === 'Currencies').provider = data.project.currency.provider
										}
									}
								}
							}
						}
						if (prop === 'client') {
							if (data[prop]) {
								for (let propName in data[prop]) {
									if (data[prop][propName]) {
										if (this.globalsConfig[prop].fields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1)) {
											this.globalsConfig[prop].fields.find(f => f.name.toLowerCase().indexOf(propName.toLowerCase()) > -1).value = data[prop][propName]
										}
									}
								}
							}
						}
						if (prop === 'custom') {
							if (data[prop]) {
								for (let propName in data[prop]) {
									if (data[prop][propName]) {
										this.globalsConfig[prop].fields.push(_buildCustomFieldObject(propName, data[prop][propName]))
									}
								}
							}
						}
					}
				}
			}
		},
		addCustomField () {
			if (!this.customKeyField || !this.customValueField) {
				return true
			}
			const key = this.customKeyField.trim().replaceAll(' ', '_')
			const fieldsArr = this.globalsConfig.custom.fields
			// check for existing key
			if (fieldsArr.find(f => f.label === key)) {
				return this.$store.commit('Toast/_addError', 'Key already added!')
			}
			const fieldObject = _buildCustomFieldObject(key, this.customValueField)
			this.globalsConfig.custom.fields.push(fieldObject)
			this.$nextTick(() => {
				this.customKeyField = ''
				this.customValueField = ''
			})
		},
		removeCustomField (fieldIdx) {
			this.$delete(this.globalsConfig.custom.fields, fieldIdx)
		},
		correctCustomKeyField (event) {
			const charsMap = {
				' ': '_',
				',': '',
				'.': ''
			}
			if (event.data) {
				if (charsMap.hasOwnProperty(event.data)) {
					this.customKeyField = this.customKeyField.trim().replaceAll(event.data, charsMap[event.data])
				}
			}
		},
		confirmSave () {
			const confirmation = window.confirm('Save current configuration?')
			if (confirmation) {
				this.save()
			}
		},
		validateInput (event) {
			event.target.classList.remove('error')
			if (!_isInputValid(event.target)) {
				event.target.classList.add('error')
			}
		},
		save () {
			const form = document.forms.configs
			const formElements = Array.from(form.elements)
			// reset input errors
			formElements.forEach(inp => {
				inp.classList.remove('error')
			})
			let fieldName
			let val
			const data = {}
			const arrayInputsObj = {}
			let formValid = true
			let firstErrInpName = null
			if (!form.checkValidity()) {
				formElements.forEach(inp => {
					if (!_isInputValid(inp)) {
						if (!firstErrInpName) {
							firstErrInpName = inp.name
						}
						inp.classList.add('error')
						formValid = false
					}
				})
				if (!formValid) {
					if (firstErrInpName) {
						document.querySelector('[name="' + firstErrInpName + '"]').parentElement.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
							inline: 'nearest'
						})
					}
					return this.$store.commit('Toast/_addError', 'Please correct the error inputs')
				}
			}
			Array.from(form.elements).filter(f => ['input', 'select', 'textarea'].indexOf(f.tagName.toLowerCase()) >= 0).forEach(f => {
				fieldName = f.name
				val = f.value
				// fallback to defaultValue if value is not completed by user
				if (!val && f.defaultValue) {
					val = f.defaultValue
				}
				if (f.type === 'file' && f.files.length) {
					val = f.files[0]
				}
				// check if field name ends in '[]' => array input
				if (fieldName.slice(-2) === '[]') {
					arrayInputsObj[fieldName] = arrayInputsObj[fieldName] || []
					arrayInputsObj[fieldName].push(val)
				} else if (fieldName.length) {
					// regular input, add to data
					data[fieldName] = val
				}
			})
			// check if any array inputs added found and add to data
			if (Object.keys(arrayInputsObj).length) {
				Object.keys(arrayInputsObj).forEach((fName, inpIdx) => {
					const baseFieldName = fName.slice(0, -2)
					arrayInputsObj[fName].forEach((val, valIdx) => {
						data[`${baseFieldName}[${valIdx}]`] = val
					})
				})
			}
			// go through data and take out file type inputs for separate upload request
			for (let field in data) {
				if (field === 'sitemap' || field === 'robots') {
					if (data[field]) {
						this.uploadFile(field, data[field])
						delete data[field]
					} else {
						delete data[field]
					}
				} else {
					// formdata.append(field, data[field])
				}
			}
			if (!Object.keys(data).length) {
				return true
			}
			const _buildJSONData = (data) => {
				const globalsData = {}
				const params = new FormData(document.forms.configs)
				for (var pair of params.entries()) {
					const fieldName = pair[0]
					let fieldVal = pair[1]
					if (fieldVal === 'on' && document.forms.configs.elements[fieldName].type === 'checkbox') {
						fieldVal = '1'
					}
					if (fieldName.indexOf('decloakSnippet') > -1) {
						if (fieldVal == parseInt(fieldVal)) {
							fieldVal = parseInt(fieldVal)
						}
					}
					// temp obj starting from globalsData obj, for each field
					let tempObj = globalsData
					if (fieldName.indexOf('.') > -1) {
						const parts = fieldName.split('.')
						parts.forEach((part, idx) => {
							if (idx !== parts.length - 1) {
								// not last part
								tempObj[part] = tempObj[part] || {}
								// go next level with tempObj
								tempObj = tempObj[part]
							} else {
								// last part (last key from chain)
								if (part.indexOf('[]') > -1) {
									// array field
									if (tempObj.hasOwnProperty(part.split('[]')[0])) {
										// existing array value
										if (fieldVal) {
											tempObj[part.split('[]')[0]].push(fieldVal)
										}
									} else {
										// create array value
										if (fieldVal) {
											tempObj[part.split('[]')[0]] = [fieldVal]
										}
									}
								} else {
									// non-array field
									if (fieldVal) {
										tempObj[part] = fieldVal
									}
								}
							}
						})
					} else if (['robots', 'sitemap'].indexOf(fieldName) === -1) {
						if (fieldVal) {
							tempObj[fieldName] = fieldVal
						}
					}
				}

				return globalsData
			}
			// console.log('GLOBALS: ', _buildJSONData(data))

			// if no other data remaining, don't do another request
			this.$store.dispatch('Configuration/save', {
				data: {
					configuration: JSON.stringify(_buildJSONData(data))
				}
			})
		},
		uploadFile (field, file) {
			const formdata = new FormData()
			formdata.append(field, file)
			formdata.append('UserId', this.$store.getters.getCookie('userId'))
			formdata.append('Token', this.$store.getters.getCookie('token'))
			formdata.append('Workspace', this.USER)
			formdata.append('Project', this.PROJECT)
			const xhr = new XMLHttpRequest();
			xhr.open('POST', this.CMS_BASE_URL + '/cms/configuration');
			xhr.setRequestHeader('Authorization', this.$store.getters.getCookie('token'));
			xhr.onload = () => {
				this.$store.dispatch('Toast/_add', 'Saved succesfully')
			}
			xhr.upload.onerror = (e) => {
				this.$store.dispatch('Toast/_addError', 'Failed uploading ' + field)
			}
			// xhr.upload.onprogress = function(e){
			// 	if(e.lengthComputable) {
			// 		// $row.find('.progress').css('width',(e.loaded/e.total*100 | 0)+'%' );
			// 		console.log(e.loaded/e.total*100 | 0)
			// 	}
			// };
			xhr.send(formdata);
		},
		fieldNotLangOrCurr (field) {
			return field.name.toLowerCase().indexOf('language') === -1 &&
				field.name.toLowerCase().indexOf('exchange') === -1 &&
				field.name.toLowerCase().indexOf('currenc') === -1
		},
		fieldConditionPass (field) {
			let passd = false
			if (
				!field.hasOwnProperty('condition')
			) {
				passd = true
			} else {
				if (typeof field.condition === 'object') {
					if (field.condition.hasOwnProperty('urlSubstring')) {
						return window.location.href.indexOf(field.condition.urlSubstring) > -1
					}
					if (field.condition.hasOwnProperty('urlParam')) {
						return window.location.href.indexOf(`${field.condition.urlParam}=true`) > -1
					}
				} else {
					return field.condition
				}
			}
			return passd
		},
		onContainerFieldSelected (event, field) {
			if (event.target.value) {
				field.tempItems.push(event.target.value)
			}
			this.$nextTick(() => {
				setTimeout(function () {
					event.target.value = ''
					field.value = ''
				}, 150)
			})
		}
	},
	computed: {
		...mapState(['Pages', 'Configuration']),
		retrievedData () {
			return this.Configuration ? JSON.parse(JSON.stringify(this.Configuration.data)) : null
		},
		cmsVersion () {
			return this.Configuration && this.Configuration.globals ? this.Configuration.globals.config.version : ''
		}
	},
	async beforeMount () {
		this.$store.dispatch('Pages/fetchAll')
		await this.$store.dispatch('Configuration/fetch')
		if (this.Configuration.data) {
			this.dataFill()
		}
	}
}
</script>
<style lang="scss">
code {
	background-color: #444;
	padding: 0.25em 0.5em;
	border-radius: 0.25em;
}
form[name="configs"] {
	input, select, textarea, .confield {
		padding:0.6em;
		border-width:1px;
		border-style: solid;
		border-color: #111;
		border-radius:0.25em;
		color-scheme: dark;
		font-size: 16px;
		&:focus-visible {
			outline: 1px solid #000;
		}
		&.error {
			border-color:red;
		}
	}
	.typeahead > a {
		text-decoration: none!important;
	}
}
.form-section-container {
	:input, select {
		padding:5px 10px;
		border-radius:5px;
	}
}
</style>
<style lang="scss" scoped>
.sub-sub-heading > p > strong {
	color: #69d543;
}
td p {
	font-size:15px;
}
.confield {
	padding: 3px 5px;
	min-width:24rem;
}
.sub-heading {
	padding: 30px 15px 10px;
	// border-bottom: 2px dashed #ffffff1a;
}
.sub-sub-heading {
	padding: 20px 15px 5px;
}
.config-main-lvl {
	background-color:#262d36;
	border:2px solid transparent;
	padding-bottom:20px;
	margin-bottom:20px;
	table {
		position:relative;
		overflow:visible;
		opacity:0.85;
		z-index:10;
		&:hover {
			z-index: 15;
		}
	}
	&:hover {
		border:2px dashed #42505f;
		// background-color: #7fc4ff1f;
		// background-image: repeating-linear-gradient(45deg, #262c348c, #20262e 15px);
		background-color: #2a323c;
		table {
			opacity: 0.95;
		}
	}
}
tr.list-item {
	.customfield-rem {
		position:absolute;
		opacity:0.3;
		color:#aaa;
		transition: all 0.3s ease-out;
	}
	&:hover {
		.customfield-rem {
			opacity:1;
			color:red;
			transform: scale(1.25);
		}
	}
	&:has(.confield.error) {
		background-color:#352a1a;
	}
}
.btn.btn-green.btn-save {
	display: inline-block;
	padding: 0.75em 5em;
	height: auto;
	font-size: 18px;
	font-weight: 600;
	letter-spacing: 1px;
}
</style>
